import React, { Component } from "react";
import "./VideosRowItem.css";
import "./VideoPlayerItem.css";
import * as encryptUtils from "./encryptDecryptUtils";
import * as loggingUtils from "./utils/loggingUtils";
import * as scriptUtils from "./utils/scriptUtils";
import LitJsSdk from "lit-js-sdk";
import axios from "axios";
import lottie from 'lottie-web';
import PlatformSidebar from "./PlatformSidebar";
import Onboarding from "./Onboarding.js";
import AddFunds from "./AddFunds.js";
import SubscribeModal from "./SubscribeModal.js";
import ChatAndFlyingObjects from "./ChatAndFlyingObjects.js";
import ImportFromPassword from "./ImportFromPassword";
import ItemDedicatedPageVOD from "./ItemDedicatedPageVOD";
import ItemMintDetails from "./ItemMintDetails";
import ItemMintMonetizationDetails from "./ItemMintMonetizationDetails";
import ItemMintDescription from "./ItemMintDescription";
import LivestreamPage from "./LivestreamPage";
import TransactionStatus from "./TransactionStatus";
import PlatformMusicPlayer from "./PlatformMusicPlayer";
import BondingCurveAccordion from "./BondingCurveAccordion";
import { createAlchemyWeb3 } from "@alch/alchemy-web3";
import { TwitterShareButton } from 'react-twitter-embed';
import ReactHlsPlayer from 'react-hls-player';
import {
  contractAddress,
  mainnetContractAddress,
  bondingCurveContractAddress,
  bondingCurveOrchestratorContractAddress,
  mainnetBondingCurveContractAddress,
  mainnetBondingCurveOrchestratorContractAddress
} from "./config";
import { FaPause, FaPlay } from "react-icons/fa";
import CreateLiveStreamButton from "./CreateLiveStreamButton";
import ShowLiveStream from "./ShowLiveStream";
const contract = require("./artifacts/contracts/The402NFT.sol/The402NFT.json");
const contract2 = require("./artifacts/contracts/BondingCurveNFT.sol/BondingCurveNFT.json");
const contract3 = require("./artifacts/contracts/BondingCurveOrchestrator.sol/BondingCurveOrchestrator.json");
const animation = require("./animation.json");

let web3;
let usedContractAddress;
let usedContractAddressBondingCurve;
let usedContractAddressBondingCurveV2;
if(process.env.REACT_APP_IS_MAINNET !== "testnet") {
  web3 = createAlchemyWeb3(process.env.REACT_APP_ETHEREUM_WEBSOCKET_URL);
  usedContractAddress = mainnetContractAddress;
  usedContractAddressBondingCurve = mainnetBondingCurveContractAddress;
  usedContractAddressBondingCurveV2 = mainnetBondingCurveOrchestratorContractAddress;
} else {
  web3 = createAlchemyWeb3(process.env.REACT_APP_GOERLI_WEBSOCKET_URL);
  usedContractAddress = contractAddress;
  usedContractAddressBondingCurve = bondingCurveContractAddress;
  usedContractAddressBondingCurveV2 = bondingCurveOrchestratorContractAddress;
}

const DURATION = 5000;

// TODO this file has some hard coded things for the Tweet button for Ahmed and recorded video for Mike and venmo/addr for Dom

class ItemDedicatedPage extends Component {
  constructor(props) {
    super(props);
    this.addAddress = this.addAddress.bind(this);
    this.copyVenmo = this.copyVenmo.bind(this);
    this.copyAddress = this.copyAddress.bind(this);
    this.removeAddress = this.removeAddress.bind(this);
    this.fetchInfo = this.fetchInfo.bind(this);
    this.litDecrypt = this.litDecrypt.bind(this);
    this.onPlayAudio = this.onPlayAudio.bind(this);
    this.revokeAccess = this.revokeAccess.bind(this);
    this.selectModal = this.selectModal.bind(this);
    this.setTransactionStatus = this.setTransactionStatus.bind(this);
    this.onUserClickedConnectWallet =
      this.onUserClickedConnectWallet.bind(this);
    this.updateUserInfo = this.updateUserInfo.bind(this);
    this.updatePlayingStatus = this.updatePlayingStatus.bind(this);
    this.getStream = this.getStream.bind(this);
    this.setAddresses = this.setAddresses.bind(this);
    this.setShouldShowAddress = this.setShouldShowAddress.bind(this);
    this.setAnimatedImageForUser = this.setAnimatedImageForUser.bind(this);
    this.setCrossmintUserId = this.setCrossmintUserId.bind(this);
    this.addMessage = this.addMessage.bind(this);
    this.updateCurrentMessage = this.updateCurrentMessage.bind(this);
    this.setENS = this.setENS.bind(this);
    this.markAsSubscribed = this.markAsSubscribed.bind(this);
    this.selectSubscribeModal = this.selectSubscribeModal.bind(this);
    this.onVODPlay = this.onVODPlay.bind(this);
    this.mintFromChat = this.mintFromChat.bind(this);
    this.payStreamer = this.payStreamer.bind(this);
    this.logMinuteAttended = this.logMinuteAttended.bind(this);
    this.triggerAnimation = this.triggerAnimation.bind(this);
    this.setMessageInfo = this.setMessageInfo.bind(this);
    this.addPaginatedMessages = this.addPaginatedMessages.bind(this);
    this.addSubscribedMessage = this.addSubscribedMessage.bind(this);

    this.state = {
      authUUIDCrossmintClientMapping: {},
      balance: 0,
      hasClicked: false,
      itemFile: null,
      isPlayingAudio: false,
      isDecrypting: false,
      creatorImage: "https://pbs.twimg.com/profile_images/1521659343309086720/2Lle15fa_400x400.png",
      creatorName: "",
      emotes: [],
      livestreamURLsByAuthUUID: {},
      liveTimesByAuthUUID: {},
      nftSalesLivestream: {},
      socials: {},
      item: null,
      modalShown: "",
      transactionStatus: "None",
      protocol: null,
      isActive: false,
      stream: null,
      addresses: [],
      animatedImageForUser: {},
      shouldShowAddress: {},
      crossmintUserId: null,
      crossmintTokenBalance: 0,
      messages: [],
      nextToken: null,
      currentMessage: '',
      ens: '',
      shouldStreamInTestMode: true,
      subscriberStatuses: {},
      userInfo: null,
      badgeInfo: null,
      userOwnedNFTs: [],
      secondsWatched: 0
    };
  }

  addSubscribedMessage(value) {
    if(value != null && value.data != null && value.data.messageSent != null) {
      let messages = this.state.messages.reverse();
      let newMessage = value.data.messageSent;
      messages.push(newMessage);
      this.setState({
        messages,
      });
    }
  }

  addPaginatedMessages(messageInfo) {
    if(messageInfo != null && messageInfo.data != null && messageInfo.data.getMessages != null) {
      let messages = messageInfo.data.getMessages["messages"].reverse();
      let recentMessages = this.state.messages;
      messages = messages.concat(recentMessages);
      let nextToken = messageInfo.data.getMessages["nextToken"];
      this.setState({
        messages,
        nextToken
      });
    }
  }

  setMessageInfo(messageInfo) {
    if(messageInfo != null && messageInfo.data != null && messageInfo.data.getMessages != null) {
      let messages = messageInfo.data.getMessages["messages"];
      let nextToken = messageInfo.data.getMessages["nextToken"];
      this.setState({
        messages,
        nextToken
      });
    }
  }

  updateUserInfo(userInfo) {
    this.setState({
      userInfo,
    });
  }

  async logMinuteAttended(player) {
    if(player.current != null) {
      let secondsWatched = 0;
      for(let i = 0; i < player.current.played.length; i++) {
        secondsWatched += player.current.played.end(i) - player.current.played.start(i)
      }
      if(Math.floor(secondsWatched/60) !== Math.floor(this.state.secondsWatched/60)) {
        this.setState({
          secondsWatched,
        });
        let userId = this.props.account != null
          ? this.props.account.address.toLowerCase()
          : encryptUtils.getWalletUnconnectedUserId();
        let badgeInfo = await encryptUtils.logMinuteAttended(this.state.item.creatorAddress, userId);
        this.setState({
          badgeInfo,
        });
      } else {
        this.setState({
          secondsWatched,
        });
      }
    }
  }

  triggerAnimation() {
    let elements = document.getElementsByClassName("videoItem-LiveStream");
    if(elements.length > 0) {
      let container = elements[0].parentElement;
      let animObj = lottie.loadAnimation({
        container: container,
        renderer: 'svg',
        loop: false,
        autoplay: true,
        animationData: animation,
        rendererSettings: {
          className: "the402-lottie-animation",
          preserveAspectRatio: 'none',
        }
      });
      animObj.setSpeed(0.4);

      animObj.addEventListener('complete', () => {
        let animations = document.getElementsByClassName("the402-lottie-animation");
        if(animations.length !== 0) {
          for(let index in animations) {
            if(typeof animations[index] === "object") {
              // Is DOM element
              animations[index].remove();
            }
          }
        }
      });
    }
  }

  copyVenmo() {
    navigator.clipboard.writeText("@domdeshawn");
  }

  copyAddress() {
    navigator.clipboard.writeText("0xf873e05C28Be2845f09C828DAe42084b6b1C060E");
  }

  selectModal(modal) {
    this.setState({
      modalShown: modal,
    });
  }

  onVODPlay() {
    loggingUtils.logEvent(
      this.props.account != null
        ? this.props.account.address
        : encryptUtils.getWalletUnconnectedUserId(),
      "item_dedicated_page",
      "item_dedicated_page_vod_play",
      "info",
      "https://the402.xyz",
      {
        authUUID: this.state.item.authUUID
      }
    );
  }

  selectSubscribeModal() {
    if(this.props.account != null) {
      this.selectModal("subscribe");
    } else {
      this.onUserClickedConnectWallet();
    }
  }

  setENS(ens) {
    this.setState({
      ens,
    });
  }

  setAddresses(addresses) {
    this.setState({
      addresses,
    });
  }

  markAsSubscribed(creator, subscriber) {
    creator = creator.toLowerCase();
    subscriber = subscriber.toLowerCase();
    let creatorMapping;
    let subscriberStatusesCopy = {...this.state.subscriberStatuses};
    if(!(creator in subscriberStatusesCopy)) {
      creatorMapping = {};
      creatorMapping[subscriber] = true;
    } else {
      creatorMapping = subscriberStatusesCopy[creator];
      creatorMapping[subscriber] = true;
    }
    subscriberStatusesCopy[creator] = creatorMapping;
    this.setState({
      subscriberStatuses: subscriberStatusesCopy,
    });
  }

  setCrossmintUserId(crossmintUserId) {
    this.setState({
      crossmintUserId
    });
  }

  addMessage(message) {
    let messagesCopy = [...this.state.messages];
    messagesCopy.push(message);
    this.setState({
      messages: messagesCopy,
    });
  }

  updateCurrentMessage(newMessage) {
    this.setState({
      currentMessage: newMessage,
    });
  }

  addAddress(joiner) {
    let users = [...this.state.addresses];
    users.push(joiner);
    this.setState({
      addresses: users,
    });
  }

  removeAddress(leaver) {
    let users = [...this.state.addresses];
    let index = users.indexOf(leaver);
    if (index !== -1) {
      users.splice(index, 1);
    }
    this.setState({
      addresses: users,
    });
  }

  setShouldShowAddress(ind, shouldShow) {
    if(shouldShow) {
      let shouldShowAddress = {};
      shouldShowAddress[ind] = true;
      this.setState({
        shouldShowAddress,
      });
    } else {
      let shouldShowAddress = {}
      this.setState({
        shouldShowAddress,
      });
    }
  }

  setTransactionStatus(status) {
    this.setState({
      transactionStatus: status,
    });
  }

  setAnimatedImageForUser(sender, image) {
    let animatedImagesCopy = {...this.state.animatedImageForUser};
    animatedImagesCopy[sender] = image;
    this.setState({
      animatedImageForUser: animatedImagesCopy
    });
    setTimeout(() => {
      animatedImagesCopy = {...this.state.animatedImageForUser};
      delete animatedImagesCopy[sender];
      this.setState({
        animatedImageForUser: animatedImagesCopy,
      });
    }, DURATION);
  }

  async mintFromChat() {
    loggingUtils.logEvent(
      this.props.account != null
        ? this.props.account.address
        : encryptUtils.getWalletUnconnectedUserId(),
      "item_dedicated_page",
      "item_dedicated_page_enter_mint_from_chat",
      "info",
      "https://the402.xyz",
      {}
    );
    if(this.state.nftSalesLivestream == null) {
      return false;
    }
    if(this.props.account == null) {
      this.onUserClickedConnectWallet();
      return false;
    }
    this.setTransactionStatus("Pending");
    if(this.state.nftSalesLivestream.type === "manifold721") {
      let didApprove = await encryptUtils.buyManifold721Emote(
        this.props.account.address,
        this.state.nftSalesLivestream.contractAddress,
        this.state.nftSalesLivestream.claimIndex,
        this.state.nftSalesLivestream.price
      );
      if(didApprove) {
        loggingUtils.logEvent(
          this.props.account.address,
          "external_purchases",
          "external_purchase",
          "info",
          "https://the402.xyz",
          {
            "type": this.state.nftSalesLivestream.type,
            "price": this.state.nftSalesLivestream.price,
            "contractAddress": this.state.nftSalesLivestream.contractAddress
          }
        );
        this.setTransactionStatus("Purchase Complete");
        return true;
      } else {
        this.setTransactionStatus("None");
        return false;
      }
    } else if(this.state.nftSalesLivestream.type === "manifold1155") {
      let didApprove = await encryptUtils.buyManifold1155Emote(
        this.props.account.address,
        this.state.nftSalesLivestream.contractAddress,
        this.state.nftSalesLivestream.price,
        this.state.nftSalesLivestream.tokenId
      );
      if(didApprove) {
        loggingUtils.logEvent(
          this.props.account.address,
          "external_purchases",
          "external_purchase",
          "info",
          "https://the402.xyz",
          {
            "type": this.state.nftSalesLivestream.type,
            "price": this.state.nftSalesLivestream.price,
            "contractAddress": this.state.nftSalesLivestream.contractAddress
          }
        );
        this.setTransactionStatus("Purchase Complete");
        return true;
      } else {
        this.setTransactionStatus("None");
        return false;
      }
    } else if(this.state.nftSalesLivestream.type === "zora721") {
      let didApprove = await encryptUtils.buyZora721Emote(
        this.props.account.address,
        this.state.nftSalesLivestream.contractAddress,
        this.state.nftSalesLivestream.price
      );
      if(didApprove) {
        loggingUtils.logEvent(
          this.props.account.address,
          "external_purchases",
          "external_purchase",
          "info",
          "https://the402.xyz",
          {
            "type": this.state.nftSalesLivestream.type,
            "price": this.state.nftSalesLivestream.price,
            "contractAddress": this.state.nftSalesLivestream.contractAddress
          }
        );
        this.setTransactionStatus("Purchase Complete");
        return true;
      } else {
        this.setTransactionStatus("None");
        return false;
      }
    } else if(this.state.nftSalesLivestream.type === "poap") {
      let didApprove = await encryptUtils.claimPOAP(this.props.account.address);
      if(didApprove) {
        loggingUtils.logEvent(
          this.props.account.address,
          "poap",
          "poap_claim",
          "info",
          "https://the402.xyz",
          {
            "type": this.state.nftSalesLivestream.type
          }
        );
        this.setTransactionStatus("Claim Complete");
        return true;
      } else {
        this.setTransactionStatus("None");
        return false;
      }
    }
  }

  async payStreamer(amount) {
    if(this.props.account != null) {
      loggingUtils.logEvent(
        this.props.account.address,
        "item_dedicated_page",
        "item_dedicated_page_enter_pay_streamer_flow",
        "info",
        "https://the402.xyz",
        {}
      );
      this.setState({
        transactionStatus: "Pending",
      });
      let didApprove = await encryptUtils.payStreamer(
        this.props.account.address,
        this.state.item.creatorAddress,
        amount
      );
      if (!didApprove) {
        this.setState({
          transactionStatus: "None",
        });
        return false;
      } else {
        loggingUtils.logEvent(
          this.props.account.address,
          "external_payments",
          "external_payment",
          "info",
          "https://the402.xyz",
          {}
        );
        let newBadgeInfo = await encryptUtils.logMicropayment(
          this.state.item.creatorAddress,
          this.props.account.address,
          amount
        );
        this.setState({
          badgeInfo: newBadgeInfo,
          transactionStatus: "Payment Complete"
        });
        return true;
      }
    } else {
      this.onUserClickedConnectWallet();
      return false;
    }
  }

  onUserClickedConnectWallet() {
    loggingUtils.logEvent(
      encryptUtils.getWalletUnconnectedUserId(),
      "item_dedicated_page",
      "item_dedicated_page_like_item_with_wallet_disconnected",
      "info",
      "https://the402.xyz",
      {}
    );
    let buttons = document.getElementsByTagName("button");
    for (let i = 0; i < buttons.length; i++) {
      let button = buttons[i];
      if (button.outerText === "Connect Wallet") {
        button.click();
      }
    }
  }

  updatePlayingStatus() {
    this.setState({
      isPlayingAudio: !this.state.isPlayingAudio,
    });
  }

  onPlayAudio() {
    let buttons = document.getElementsByClassName(
      "platformMusicPlayer-playButtonBackground"
    );
    if (buttons.length > 0) {
      buttons[0].click();
    }
  }

  async fetchInfo() {
    let urlSplit = window.location.href.split("/");
    let authUUID = decodeURIComponent(urlSplit[urlSplit.length - 1]);
    if (authUUID.includes("&autorefresh=true")) {
      authUUID = authUUID.split("&autorefresh=true")[0];
    }
    let itemInfoSplit = authUUID.split("?protocol=");
    authUUID = decodeURIComponent(itemInfoSplit[0]);
    let protocol = itemInfoSplit[1];
    let [item, subscriberStatuses] = await Promise.all([
      encryptUtils.getNFTDetails(authUUID, protocol),
      encryptUtils.getSubscriberStatuses()
    ]);
    if (item == null) {
      return;
    }
    item["artist"] = item["creatorName"];
    item["image"] = item["imagePinata"];

    this.setState({
      item,
      protocol,
      subscriberStatuses,
    });

    let userId = this.props.account != null
        ? this.props.account.address.toLowerCase()
        : encryptUtils.getWalletUnconnectedUserId();
    let [
      shouldShowLiveStream,
      streamerProfileInfo,
      userInfo,
      badgeInfo,
      userOwnedNFTs,
      dummyStreamInfo
    ] = await Promise.all([
      encryptUtils.getShouldShowLivestreamForVOD(
        this.props.account != null ? this.props.account.address : "",
        item,
        item["creatorAddress"]
      ),
      encryptUtils.getStreamerProfileInfo(item.creatorAddress),
      encryptUtils.getUserProfileInfo(userId),
      encryptUtils.getBadgeInfo(item.creatorAddress, userId),
      encryptUtils.getUserOwnedNFTImages(userId),
      this.getStream()
    ]);
    this.setState({
      shouldShowLiveStream,
      badgeInfo,
      userInfo,
      userOwnedNFTs,
    });
    let crossmintUserId = encryptUtils.getCrossmintUserId();
    this.setCrossmintUserId(crossmintUserId);
    if(Object.keys(streamerProfileInfo).length > 0) {
      this.setState({
        authUUIDCrossmintClientMapping: streamerProfileInfo.authUUIDCrossmintClientMapping,
        creatorImage: streamerProfileInfo.creatorImage,
        creatorName: streamerProfileInfo.creatorName,
        emotes: streamerProfileInfo.emotes,
        livestreamURLsByAuthUUID: streamerProfileInfo.livestreamURLsByAuthUUID,
        liveTimesByAuthUUID: streamerProfileInfo.liveTimesByAuthUUID,
        nftSalesLivestream: streamerProfileInfo.nftSalesLivestream,
        shouldStreamInTestMode: streamerProfileInfo.shouldStreamInTestMode,
        socials: streamerProfileInfo.socials
      });
    }

    let self = this;
    const ppvContract = new web3.eth.Contract(contract.abi, usedContractAddress);
    const bondingCurveContract = new web3.eth.Contract(contract2.abi, usedContractAddressBondingCurve);
    const bondingCurveV2Contract = new web3.eth.Contract(
      contract3.abi,
      usedContractAddressBondingCurveV2
    );
    ppvContract.events
      .ItemMinted()
      .on("data", function (event) {
        let data = event.returnValues;
        console.log(data);
        if (data["authUUID"] !== item["authUUID"]) {
          return;
        }
        item["mintCount"] =
          parseInt(item["mintCount"]) + parseInt(data["count"]);
        self.setState({
          item,
        });
        if (
          self.props.account == null ||
          data["to"].toLowerCase() !== self.props.account.address.toLowerCase()
        ) {
          return;
        }
        self.setState({
          transactionStatus: "Mint Complete",
        });
      })
      .on("error", function (event) {
        self.setState({
          transactionStatus: "Failed",
        });
      });
    bondingCurveContract.events
      .ItemMinted()
      .on("data", async function (event) {
        let data = event.returnValues;
        console.log(data);
        if (data["authUUID"] !== item["authUUID"]) {
          return;
        }
        let pastBondingCurveMintEvents = await bondingCurveContract.getPastEvents("ItemMinted", {
          fromBlock: 0,
          toBlock: 'latest'
        });
        let pastBondingCurveBurnEvents = await bondingCurveContract.getPastEvents("ItemBurned", {
          fromBlock: 0,
          toBlock: 'latest'
        });
        let filteredPastBondingCurveMintEvents = pastBondingCurveMintEvents.filter(event => event.returnValues.authUUID === item.authUUID);
        let filteredPastBondingCurveBurnEvents = pastBondingCurveBurnEvents.filter(event => event.returnValues.authUUID === item.authUUID);
        let newSupply = filteredPastBondingCurveMintEvents.length - filteredPastBondingCurveBurnEvents.length;
        let tokenId = item["tokenId"];
        let currentBuyPrice = await encryptUtils.computeCurrentPrice(tokenId, newSupply + 1, "liquid");
        let currentSellPrice = await encryptUtils.computeCurrentPrice(tokenId, newSupply, "liquid");
        let moneyInContract = await encryptUtils.computeMoneyInContract(tokenId, "liquid");
        let currentBuyFeePerThousand = item["currentBuyFeePerThousand"];
        let currentSellFeePerThousand = item["currentSellFeePerThousand"];
        item["baseBuyPrice"] = currentBuyPrice;
        item["baseSellPrice"] = currentSellPrice;
        currentBuyPrice *= (1 + currentBuyFeePerThousand/1000);
        currentSellPrice *= (1 - (currentSellFeePerThousand + 25)/1000);
        item["mintPrice"] = currentBuyPrice;
        item["sellPrice"] = currentSellPrice;
        item["moneyInContract"] = moneyInContract;
        item["currentSupply"] = newSupply;
        self.setState({
          item,
        });
        if (
          self.props.account == null ||
          data["to"].toLowerCase() !== self.props.account.address.toLowerCase()
        ) {
          return;
        }
        self.setState({
          transactionStatus: "Mint Complete",
        });
      })
      .on("error", function (event) {
        self.setState({
          transactionStatus: "Failed",
        });
      });
    bondingCurveContract.events
      .ItemBurned()
      .on("data", async function (event) {
        let data = event.returnValues;
        console.log(data);
        if (data["authUUID"] !== item["authUUID"]) {
          return;
        }
        let pastBondingCurveMintEvents = await bondingCurveContract.getPastEvents("ItemMinted", {
          fromBlock: 0,
          toBlock: 'latest'
        });
        let pastBondingCurveBurnEvents = await bondingCurveContract.getPastEvents("ItemBurned", {
          fromBlock: 0,
          toBlock: 'latest'
        });
        let filteredPastBondingCurveMintEvents = pastBondingCurveMintEvents.filter(event => event.returnValues.authUUID === item.authUUID);
        let filteredPastBondingCurveBurnEvents = pastBondingCurveBurnEvents.filter(event => event.returnValues.authUUID === item.authUUID);
        let newSupply = filteredPastBondingCurveMintEvents.length - filteredPastBondingCurveBurnEvents.length;
        let tokenId = item["tokenId"];
        let currentBuyPrice = await encryptUtils.computeCurrentPrice(tokenId, newSupply + 1, "liquid");
        let currentSellPrice = await encryptUtils.computeCurrentPrice(tokenId, newSupply, "liquid");
        let moneyInContract = await encryptUtils.computeMoneyInContract(tokenId, "liquid");
        let currentBuyFeePerThousand = item["currentBuyFeePerThousand"];
        let currentSellFeePerThousand = item["currentSellFeePerThousand"];
        item["baseBuyPrice"] = currentBuyPrice;
        item["baseSellPrice"] = currentSellPrice;
        currentBuyPrice *= (1 + currentBuyFeePerThousand/1000);
        currentSellPrice *= (1 - (currentSellFeePerThousand + 25)/1000);
        item["mintPrice"] = currentBuyPrice;
        item["sellPrice"] = currentSellPrice;
        item["moneyInContract"] = moneyInContract;
        item["currentSupply"] = newSupply;
        self.setState({
          item,
        });
        if (
          self.props.account == null ||
          data["burner"].toLowerCase() !== self.props.account.address.toLowerCase()
        ) {
          return;
        }
        self.setState({
          transactionStatus: "Burn Complete",
        });
      })
      .on("error", function (event) {
        self.setState({
          transactionStatus: "Failed",
        });
      });
    bondingCurveV2Contract.events
      .ItemMinted()
      .on("data", async function (event) {
        let data = event.returnValues;
        console.log(data);
        if (data["authUUID"] !== item["authUUID"]) {
          return;
        }
        let pastBondingCurveMintEvents = await bondingCurveV2Contract.getPastEvents("ItemMinted", {
          fromBlock: 0,
          toBlock: 'latest'
        });
        let pastBondingCurveBurnEvents = await bondingCurveV2Contract.getPastEvents("ItemBurned", {
          fromBlock: 0,
          toBlock: 'latest'
        });
        let filteredPastBondingCurveMintEvents = pastBondingCurveMintEvents.filter(event => event.returnValues.authUUID === item.authUUID);
        let filteredPastBondingCurveBurnEvents = pastBondingCurveBurnEvents.filter(event => event.returnValues.authUUID === item.authUUID);
        let newSupply = filteredPastBondingCurveMintEvents.length - filteredPastBondingCurveBurnEvents.length;
        let tokenId = item["tokenId"];
        let currentBuyPrice = await encryptUtils.computeCurrentPrice(tokenId, newSupply + 1, "liquidv2");
        let currentSellPrice = await encryptUtils.computeCurrentPrice(tokenId, newSupply, "liquidv2");
        let moneyInContract = await encryptUtils.computeMoneyInContract(tokenId, "liquidv2");
        let currentBuyFeePerThousand = item["currentBuyFeePerThousand"];
        let currentSellFeePerThousand = item["currentSellFeePerThousand"];
        item["baseBuyPrice"] = currentBuyPrice;
        item["baseSellPrice"] = currentSellPrice;
        currentBuyPrice *= (1 + currentBuyFeePerThousand/1000);
        currentSellPrice *= (1 - (currentSellFeePerThousand + 25)/1000);
        item["mintPrice"] = currentBuyPrice;
        item["sellPrice"] = currentSellPrice;
        item["moneyInContract"] = moneyInContract;
        item["currentSupply"] = newSupply;
        self.setState({
          item,
        });
        if (
          self.props.account == null ||
          data["to"].toLowerCase() !== self.props.account.address.toLowerCase()
        ) {
          return;
        }
        self.setState({
          transactionStatus: "Mint Complete",
        });
      })
      .on("error", function (event) {
        self.setState({
          transactionStatus: "Failed",
        });
      });
    bondingCurveV2Contract.events
      .ItemBurned()
      .on("data", async function (event) {
        let data = event.returnValues;
        console.log(data);
        if (data["authUUID"] !== item["authUUID"]) {
          return;
        }
        let pastBondingCurveMintEvents = await bondingCurveV2Contract.getPastEvents("ItemMinted", {
          fromBlock: 0,
          toBlock: 'latest'
        });
        let pastBondingCurveBurnEvents = await bondingCurveV2Contract.getPastEvents("ItemBurned", {
          fromBlock: 0,
          toBlock: 'latest'
        });
        let filteredPastBondingCurveMintEvents = pastBondingCurveMintEvents.filter(event => event.returnValues.authUUID === item.authUUID);
        let filteredPastBondingCurveBurnEvents = pastBondingCurveBurnEvents.filter(event => event.returnValues.authUUID === item.authUUID);
        let newSupply = filteredPastBondingCurveMintEvents.length - filteredPastBondingCurveBurnEvents.length;
        let tokenId = item["tokenId"];
        let currentBuyPrice = await encryptUtils.computeCurrentPrice(tokenId, newSupply + 1, "liquidv2");
        let currentSellPrice = await encryptUtils.computeCurrentPrice(tokenId, newSupply, "liquidv2");
        let moneyInContract = await encryptUtils.computeMoneyInContract(tokenId, "liquidv2");
        let currentBuyFeePerThousand = item["currentBuyFeePerThousand"];
        let currentSellFeePerThousand = item["currentSellFeePerThousand"];
        item["baseBuyPrice"] = currentBuyPrice;
        item["baseSellPrice"] = currentSellPrice;
        currentBuyPrice *= (1 + currentBuyFeePerThousand/1000);
        currentSellPrice *= (1 - (currentSellFeePerThousand + 25)/1000);
        item["mintPrice"] = currentBuyPrice;
        item["sellPrice"] = currentSellPrice;
        item["moneyInContract"] = moneyInContract;
        item["currentSupply"] = newSupply;
        self.setState({
          item,
        });
        if (
          self.props.account == null ||
          data["burner"].toLowerCase() !== self.props.account.address.toLowerCase()
        ) {
          return;
        }
        self.setState({
          transactionStatus: "Burn Complete",
        });
      })
      .on("error", function (event) {
        self.setState({
          transactionStatus: "Failed",
        });
      });

    if(item.history != null) {
      item = await encryptUtils.getENSForItemHistory(item);
      this.setState({
        item,
      });
    }

    if(protocol === "the402") {
      let hasPriorAccess;
      if (this.props.account == null) {
        hasPriorAccess = false;
      } else {
        hasPriorAccess = await encryptUtils.isAuthorized(
          this.props.account.address,
          item["authUUID"]
        );
      }
      if (hasPriorAccess) {
        await this.litDecrypt();
      }
    }
    loggingUtils.logEvent(
      this.props.account != null
        ? this.props.account.address
        : encryptUtils.getWalletUnconnectedUserId(),
      "item_dedicated_page",
      "item_dedicated_page_load",
      "info",
      "https://the402.xyz",
      {}
    );
  }

  async componentDidMount() {
    let urlSplit = window.location.href.split("/");
    let authUUID = decodeURIComponent(urlSplit[urlSplit.length - 1]);
    if (authUUID.includes("?autorefresh=true")) {
      authUUID = authUUID.split("?autorefresh=true")[0];
      let self = this;
      async function waitUntilLoaded() {
        return await new Promise((resolve) => {
          const interval = setInterval(async () => {
            if (self.state.item != null) {
              resolve();
              clearInterval(interval);
            } else {
              await self.fetchInfo();
            }
          }, 2000);
        });
      }
      waitUntilLoaded();
    } else {
      await this.fetchInfo();
    }
  }

  async componentDidUpdate(prevProps) {
    if (
      this.props.account !== prevProps.account &&
      this.props.account != null &&
      this.state.item != null
    ) {
      let shouldShowLiveStream = await encryptUtils.getShouldShowLivestreamForVOD(
        this.props.account != null ? this.props.account.address : "",
        this.state.item,
        this.state.item["creatorAddress"]
      );
      this.setState({
        shouldShowLiveStream,
      });
      let crossmintUserId = encryptUtils.getCrossmintUserId();
      this.setCrossmintUserId(crossmintUserId);

      let hasPriorAccess = await encryptUtils.isAuthorized(
        this.props.account.address,
        this.state.item["authUUID"]
      );
      if (hasPriorAccess) {
        await this.litDecrypt();
      }
    }
  }

  async litDecrypt() {
    if(this.state.item["protocol"] === "liquid" || this.state.item["protocol"] === "liquidv2") {
      if(this.state.item["animation_url"] != null) {
        let item = this.state.item;
        item["url"] = item["animation_url"];
        let animationURLData = await fetch(item["url"]);
        let blob = await animationURLData.blob();
        this.setState({
          isDecrypting: false,
          item,
          itemFile: blob,
          transactionStatus: "None",
          isPlayingAudio: true,
        });
      }
      return;
    }
    if (this.state.isDecrypting) {
      return;
    }
    this.setState({
      isDecrypting: true,
    });
    if (this.props.account == null) {
      return;
    }
    this.setState({ hasClicked: true });
    if (this.state.itemFile != null) {
      return;
    }
    let authSig;
    let item = this.state.item;
    let hasPriorAccess;
    if (this.props.account == null) {
      hasPriorAccess = false;
    } else {
      hasPriorAccess = await encryptUtils.isAuthorized(
        this.props.account.address,
        item["authUUID"]
      );
    }
    if (!hasPriorAccess) {
      this.setState({
        transactionStatus: "Pending",
      });
      let didApprove = await encryptUtils.approveAccessMM(
        this.props.account.address,
        item["authUUID"],
        parseInt(item["impressionFee"])
      );
      if (!didApprove) {
        this.setState({
          hasClicked: false,
          transactionStatus: "None",
          isDecrypting: false,
        });
        return;
      }
    }
    if (
      parseInt(item["impressionFee"]) === 0 ||
      (item["mintCount"] < item["mintLimit"] && !item["isMintComplete"])
    ) {
      authSig = await encryptUtils.getAuthSigDedicatedWallet(
        process.env.REACT_APP_PRIVATE_KEY
      );
    } else {
      authSig = await encryptUtils.getAuthSig();
    }

    let ppvMetadata = await axios.get(item["uri"]);
    let symmetricKeyRaw = ppvMetadata.data.encryptedSymmetricKey;
    let encryptedSymmetricKey = Object.keys(symmetricKeyRaw).map(function (
      key
    ) {
      return symmetricKeyRaw[key];
    });
    encryptedSymmetricKey = Uint8Array.from(encryptedSymmetricKey);
    let encryptedBlob = await fetch(ppvMetadata.data.encryptedURL).then((res) =>
      res.blob()
    );
    let decryptedBlob = await encryptUtils.decryptSong(
      encryptedSymmetricKey,
      encryptedBlob,
      item["authUUID"],
      authSig
    );
    item["url"] = URL.createObjectURL(new Blob([decryptedBlob]));
    if (item["mediaType"] === 1) {
      this.setState({
        transactionStatus: "None",
        itemFile: decryptedBlob,
        item,
        isDecrypting: false,
        isPlayingAudio: true,
      });
    } else {
      this.setState({
        transactionStatus: "None",
        itemFile: decryptedBlob,
        item,
        isDecrypting: false,
        isPlayingAudio: true,
      });
    }
    loggingUtils.logEvent(
      this.props.account != null
        ? this.props.account.address
        : encryptUtils.getWalletUnconnectedUserId(),
      "item_dedicated_page",
      "item_dedicated_page_lit_decrypt",
      "info",
      "https://the402.xyz",
      {}
    );
  }

  async revokeAccess() {
    if (this.props.account == null) {
      return;
    }
    let item = this.state.item;
    await encryptUtils.revokeAccess(
      this.props.account.address,
      item["authUUID"]
    );
    this.setState({
      itemFile: null,
      hasClicked: false,
      isDecrypting: false,
      isPlayingAudio: false,
    });
    loggingUtils.logEvent(
      this.props.account != null
        ? this.props.account.address
        : encryptUtils.getWalletUnconnectedUserId(),
      "item_dedicated_page",
      "item_dedicated_page_revoke_access",
      "info",
      "https://the402.xyz",
      {}
    );
  }

  async getStream() {
    // TODO add Livepeer AWS switching logic for create stream
    if(true) {
      let result = await fetch(
        "https://73vw7wmlk1.execute-api.us-west-2.amazonaws.com/dev/get_aws_stream_info",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: this.state.item.creatorAddress,
          }),
        }
      )
        .then((res) => res.json())
        .catch((err) => console.log(err));

      if (result != null && result.isActive) {
        this.setState({
          isActive: result.isActive,
          stream: result.stream,
        });
      }
    } else {
      let urlSplit = window.location.href.split("/");
      let tokenId = urlSplit[urlSplit.length - 1].split("?")[0];

      let result = await fetch(
        "https://73vw7wmlk1.execute-api.us-west-2.amazonaws.com/dev/getStreamFromName",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: tokenId,
          }),
        }
      )
        .then((res) => res.json())
        .catch((err) => console.log(err));

      if (result != null && result.exists && result.isActive) {
        this.setState({
          isActive: result.isActive,
          stream: result.stream,
        });
      }
    }
  }

  render() {
    let url = window.location.href;
    let text = "";
    if(this.state.isActive && this.state.stream != null && this.state.shouldShowLiveStream) {
      text = "Vibing @ahmedxkazmi's token-gated livestream on @the402HQ!"
    } else {
      if(this.state.balance > 0) {
        text = "Just bought my NFT that will give me access to @ahmedxkazmi’s livestream September 12th @ 6:30pm ET on @the402HQ"
      }
    }
    let item;
    // TODO clean up styling around false && below
    if(
      this.state.item &&
      this.state.shouldShowLiveStream &&
      this.state.item.authUUID in this.state.livestreamURLsByAuthUUID
    ) {
      item = (
        <ItemDedicatedPageVOD
          authUUID={this.state.item.authUUID}
          livestreamURLsByAuthUUID={this.state.livestreamURLsByAuthUUID}
          onPlay={this.onVODPlay}
        />
      );
    } else {
      if (this.state.item && this.state.item.mediaType === 0) {
        if(this.state.item.protocol === "liquid" || this.state.item.protocol === "liquidv2") {
          item = (
            <video
              src={this.state.item.animation_url}
              controls
              loop
              muted="muted"
            ></video>
          );
        } else {
          item = (
            <video
              src={URL.createObjectURL(new Blob([this.state.itemFile]))}
              onEnded={async () => await this.revokeAccess()}
              poster={this.state.item != null && this.state.item.protocol === "the402" ? this.state.item.imagePinata : null}
              controls
            ></video>
          );
        }
      } else if (this.state.item && this.state.item.mediaType === 1) {
        // TODO reinstate blur with proper conditionals, reinstate connect wallet for  below and other media types
        item = (
          <div>
            <div className="w-screen dark:bg-zinc-900 bg-gray-200  flex justify-center py-20 items-center">
              {
                false
                  ?
                <img
                  className="backgroundBlurredImage"
                  id="blurred"
                  src={this.state.item.imagePinata}
                  alt="PPV song"
                />
                  :
                null
              }
              <div className="title-box-wrap">
                <span className="t_over"></span>
                <span className="t_over"></span>
                <span className="t_over"></span>
                <span className="t_over"></span>
                <span className="t_over"></span>
                <span className="t_over"></span>
                <span className="t_over"></span>
                <span className="t_over"></span>
                <span className="t_over"></span>
                <div className="tilt-box">
                  <div className="h-96 cursor-pointer">
                  {/*
                    {this.state.isPlayingAudio ? (
                      <FaPause
                        onClick={this.onPlayAudio}
                        className="playPauseButtons"
                      />
                    ) : (
                      <FaPlay
                        onClick={this.onPlayAudio}
                        className="playPauseButtons"
                      />
                    )}
                    */}
                    <img
                      className="h-96"
                      src={this.state.item.imagePinata}
                      onClick={this.onPlayAudio}
                      alt="PPV song"
                    />
                  </div>
                </div>
              </div>
            </div>
            {
              this.state.isActive &&
              this.state.stream != null
                ?
              null
                :
              <PlatformMusicPlayer
                song={this.state.item}
                litDecrypt={this.litDecrypt}
                revokeAccess={this.revokeAccess}
                address={
                  this.props.account != null ? this.props.account.address : null
                }
                onUserClickedConnectWallet={this.onUserClickedConnectWallet}
                updatePlayingStatus={this.updatePlayingStatus}
                backSong={() => {}}
                nextSong={() => {}}
              />
            }
          </div>
        );
      } else if(this.state.item && this.state.item.mediaType === 2) {
        // TODO reinstate blur with proper conditionals, reinstate connect wallet for  below and other media types
        item = (
          <div>
            {
              false
                ?
              <div className="w-11/12 flex justify-end">
                <div className="mt-4 bg-gray-100 dark:bg-custom-gray justify-around flex flex-col w-60 h-32 rounded-lg border-2 dark:border-teal-600 dark:shadow-[0px_0px_2px_#787878]">
                  <div className="px-4 dark:text-white text-black w-full">
                    Connect your wallet to watch the livestream
                  </div>
                  <div className="text-gray-500 dark:text-gray-400 px-4 font-medium text-md mt-2">
                    You must own a NFT for access
                  </div>
                </div>
              </div>
                :
              null
            }
            <div className="w-screen flex justify-center py-10 items-center">
              {
                false
                  ?
                <img
                  className="backgroundBlurredImage"
                  id="blurred"
                  src={this.state.item.imagePinata}
                  alt="PPV song"
                />
                  :
                null
              }
              <img src={this.state.item.imagePinata} className="relative h-auto sm:h-96" />
            </div>
          </div>
        );
      }
    }

    // TODO for now audience is always hidden in favor of new livestream page layout

    return (
      <div>
        <PlatformSidebar
          modalShown={this.state.modalShown}
          selectModal={this.selectModal}
        />
        {
          this.state.modalShown === "createAccount"
            ?
          <Onboarding selectModal={this.selectModal} />
            :
          this.state.modalShown === "addFunds"
            ?
          <AddFunds selectModal={this.selectModal} />
            :
          this.state.modalShown === "importFromPassword"
            ?
          <ImportFromPassword selectModal={this.selectModal} />
            :
          this.state.modalShown === "subscribe"
            ?
          <SubscribeModal
            selectModal={this.selectModal}
            account={this.props.account}
            item={this.state.item}
            markAsSubscribed={this.markAsSubscribed}
          />
            :
          null
        }
        <div className="min-h-screen bg-custom-white dark:bg-custom-black flex flex-col">
          <div className="flex items-center mt-16">
            <div>
              <div className="flex"></div>
              {
                this.state.isActive &&
                this.state.stream != null &&
                this.state.shouldShowLiveStream &&
                (!window.location.href.includes("app.the402.xyz") || !this.state.shouldStreamInTestMode)
                  ?
                <div className="flex flex-col">
                  <div className="w-screen flex">
                    <div>
                      <LivestreamPage
                        account={this.props.account}
                        item={this.state.item}
                        subscriberStatuses={this.state.subscriberStatuses}
                        selectSubscribeModal={this.selectSubscribeModal}
                        playbackId={this.state.stream.playbackId}
                        creatorAddress={this.state.item.creatorAddress}
                        creatorName={this.state.creatorName}
                        creatorImage={this.state.creatorImage}
                        emotes={this.state.emotes}
                        ens={this.state.ens}
                        setENS={this.setENS}
                        setAddresses={this.setAddresses}
                        addAddress={this.addAddress}
                        removeAddress={this.removeAddress}
                        addresses={this.state.addresses}
                        messages={this.state.messages}
                        addMessage={this.addMessage}
                        setAnimatedImageForUser={this.setAnimatedImageForUser}
                        setTransactionStatus={this.setTransactionStatus}
                        socials={this.state.socials}
                        currentMessage={this.state.currentMessage}
                        updateCurrentMessage={this.updateCurrentMessage}
                        nftSalesLivestream={this.state.nftSalesLivestream}
                        mintFromChat={this.mintFromChat}
                        payStreamer={this.payStreamer}
                        playbackURL={this.state.stream}
                        updateUserInfo={this.updateUserInfo}
                        userInfo={this.state.userInfo}
                        badgeInfo={this.state.badgeInfo}
                        userOwnedNFTs={this.state.userOwnedNFTs}
                        logMinuteAttended={this.logMinuteAttended}
                        triggerAnimation={this.triggerAnimation}
                        setMessageInfo={this.setMessageInfo}
                        nextToken={this.state.nextToken}
                        addPaginatedMessages={this.addPaginatedMessages}
                        addSubscribedMessage={this.addSubscribedMessage}
                      />
                      <div className="absolute dark:text-gray-200 font-bold text-gray-500 left-4 top-[70px]">
                        {this.state.addresses.length} Viewers
                      </div>
                    </div>
                  </div>
                </div>
                  :
                this.state.isActive &&
                this.state.stream != null &&
                this.state.shouldShowLiveStream &&
                (!window.location.href.includes("app.the402.xyz") || !this.state.shouldStreamInTestMode)
                  ?
                <div className="flex flex-col">
                  <div className="w-screen flex">
                    <div>
                      <ShowLiveStream
                        playbackId={this.state.stream.playbackId}
                        playbackURL={this.state.stream}
                        logMinuteAttended={this.logMinuteAttended}
                      />
                      <div className="absolute dark:text-gray-200 font-bold text-gray-500 left-4 top-[70px]">
                        {this.state.addresses.length} Viewers
                      </div>
                    </div>
                    <div className="flex justify-center flex-col">
                      <ChatAndFlyingObjects
                        address={this.props.account != null ? this.props.account.address : "anon " + Math.floor(Math.random() * 1000)}
                        creatorAddress={this.state.item.creatorAddress}
                        creatorName={this.state.creatorName}
                        emotes={this.state.emotes}
                        ens={this.state.ens}
                        setENS={this.setENS}
                        setAddresses={this.setAddresses}
                        addAddress={this.addAddress}
                        removeAddress={this.removeAddress}
                        addresses={this.state.addresses}
                        messages={this.state.messages}
                        addMessage={this.addMessage}
                        setAnimatedImageForUser={this.setAnimatedImageForUser}
                        setTransactionStatus={this.setTransactionStatus}
                        currentMessage={this.state.currentMessage}
                        mintFromChat={this.mintFromChat}
                        payStreamer={this.payStreamer}
                        updateCurrentMessage={this.updateCurrentMessage}
                        updateUserInfo={this.updateUserInfo}
                        userInfo={this.state.userInfo}
                        badgeInfo={this.state.badgeInfo}
                        userOwnedNFTs={this.state.userOwnedNFTs}
                        nftSalesLivestream={this.state.nftSalesLivestream}
                        triggerAnimation={this.triggerAnimation}
                        setMessageInfo={this.setMessageInfo}
                        nextToken={this.state.nextToken}
                        addPaginatedMessages={this.addPaginatedMessages}
                        addSubscribedMessage={this.addSubscribedMessage}
                      />
                    </div>
                  </div>
                  <div className="w-10/12 flex justify-start">
                    <div className="flex w-full justify-center">
                      <div className="w-80 md:w-10/12 mt-2 flex flex-wrap">
                      {
                        this.state.addresses.map((address, ind) => {
                          return (
                            <div key={ind}>
                              <div className="cursor-pointer flex justify-center items-center w-20 h-20 mx-2">
                                {
                                  address.toLowerCase() in this.state.animatedImageForUser
                                    ?
                                  <img
                                    src={this.state.animatedImageForUser[address.toLowerCase()]}
                                    className="w-12 h-12 rounded-full"
                                    onMouseEnter={() => this.setShouldShowAddress(ind, true)}
                                    onMouseLeave={() => this.setShouldShowAddress(ind, false)}
                                  />
                                    :
                                  <img
                                    className="w-12"
                                    src={scriptUtils.getProfileImage(address)}
                                    onMouseEnter={() => this.setShouldShowAddress(ind, true)}
                                    onMouseLeave={() => this.setShouldShowAddress(ind, false)}
                                  />
                                }
                              </div>
                              <div className={
                                ind in this.state.shouldShowAddress && this.state.shouldShowAddress[ind]
                                  ?
                                "addressContainer"
                                  :
                                "addressContainerInvisible"
                              }>
                                {address}
                              </div>
                            </div>
                          );
                        })
                      }
                      </div>
                    </div>
                  </div>
                </div>
                  :
                null
              }
              {
                this.state.item != null && (this.state.item.mediaType === 1 || this.state.item.mediaType === 2)
                  ?
                (
                  item
                )
                  :
                this.state.item != null && this.state.item.mediaType === 0 && this.state.protocol !== "the402"
                  ?
                <div className="videoItem-VideoImage">
                  {item}
                </div>
                  :
                this.state.item != null && this.state.item.mediaType === 0 && this.state.protocol === "the402"
                  ?
                (
                  <div
                    className={
                      "videoItem-VideoImage"
                    }
                    onClick={async () => {
                      if (!this.state.hasClicked) {
                        await this.litDecrypt();
                      }
                    }}
                  >
                    {item}
                  </div>
                )
                  :
                null
              }
              <div>
                {this.state.item != null ? (
                  <div className="flex w-screen justify-center">
                  <div className={
                    false && this.state.item != null && this.state.isActive && this.state.stream != null && this.state.shouldShowLiveStream
                      ?
                    "ml-8 sm:p-0 flex-col flex lg:flex-row w-full lg:w-10/12 mt-[300px] lg:justify-between items-center lg:items-start"
                      :
                    "ml-8 sm:p-0 flex-col flex lg:flex-row w-full lg:w-10/12 mt-8 lg:justify-between items-center lg:items-start"
                  }>
                    <div className="flex flex-col w-auto lg:w-1/2">
                      <div className="flex">
                        <div className= "flex flex-col w-full lg:w-10/12 lg:justify-between items-start">
                          <div className="w-96 lg:w-full">
                          {this.state.item != null &&
                          this.props.account != null &&
                          this.state.item.creatorAddress ===
                            this.props.account.address.toLowerCase() && !this.state.isActive ? (
                            <CreateLiveStreamButton
                              isForCreatorDashboard={false}
                              isForStreamerProfile={false}
                              streamName={this.state.item.creatorAddress.toLowerCase()}
                            />
                          ) : null}
                          {
                            this.state.item.authUUID === "58231507-1594-4929-9c7b-b2a42340131e"
                              ?
                              <div className="flex mb-2">
                                <div onClick={this.copyVenmo} className="cursor-pointer hover:-translate-y-0 hover:scale-105 duration-500 w-20 w-32 h-12 flex flex-col justify-center bg-blue-400 rounded-lg">
                                  <div className="ml-2 text-sm sm:text-sm text-gray-100">
                                    Venmo
                                  </div>
                                  <div className="ml-2 text-sm sm:text-md text-white dark:text-white font-bold ">
                                    @domdeshawn
                                  </div>
                                </div>
                                <div onClick={this.copyAddress} className="cursor-pointer hover:-translate-y-0 hover:scale-105 duration-500 ml-4 w-32 h-12 flex flex-col justify-center bg-zinc-600 dark:bg-zinc-800 rounded-lg">
                                  <div className="ml-2 text-sm sm:text-sm text-gray-300 dark:text-gray-400">
                                    Address
                                  </div>
                                  <div className="ml-2 text-sm sm:text-md text-white dark:text-white font-bold ">
                                    0xf87...C060E
                                  </div>
                                </div>
                              </div>
                              :
                            null
                          }
                          <div className="flex items-center">
                            <div className="text-black font-semibold dark:text-white text-2xl sm:text-4xl">
                              {
                                this.state.item != null
                                  ?
                                this.state.item.name.replaceAll("_", " ")
                                  :
                                ""
                              }
                            </div>
                            <div className="flex flex-col">
                            {
                              this.state.item.authUUID in this.state.liveTimesByAuthUUID
                                ?
                              <div className="animated-box in">
                                <div className="text-zinc-500 dark:text-zinc-400 text-sm">
                                  Live
                                </div>
                                <div className="text-black font-semibold dark:text-white">
                                  {this.state.liveTimesByAuthUUID[this.state.item.authUUID]}
                                </div>
                              </div>
                                :
                              null
                            }
                            {
                              this.state.item.authUUID === "placeholder" && text !== ""
                                ?
                              <div className="ml-4 mt-2">
                                <TwitterShareButton
                                  url={url}
                                  options={{ text: text }}
                                />
                              </div>
                                :
                              null
                            }
                            </div>
                          </div>
                            <div className="flex text-zinc-500 dark:text-zinc-400 mt-2 text-2xl">
                              {
                                this.state.item != null
                                  ?
                                this.state.item.creatorName
                                  :
                                ""
                              }
                              {
                                this.props.account != null &&
                                this.state.item.creatorAddress.toLowerCase() in this.state.subscriberStatuses &&
                                this.props.account.address.toLowerCase() in this.state.subscriberStatuses[this.state.item.creatorAddress.toLowerCase()]
                                  ?
                                <div className="cursor-pointer elative hover:-translate-y-0 hover:scale-105 duration-500 ml-4 w-20 sm:w-28 h-8 flex justify-center items-center text-sm sm:text-sm text-gray-300 dark:text-gray-400 font-bold bg-zinc-600 dark:bg-zinc-800 rounded-lg">
                                  Subscribed
                                </div>
                                  :
                                <div className="cursor-pointer elative hover:-translate-y-0 hover:scale-105 duration-500 ml-4 w-20 sm:w-28 h-8 flex justify-center items-center text-sm sm:text-sm font-bold bg-blue-600 rounded-lg text-white" onClick={() => this.selectSubscribeModal()}>
                                  Subscribe
                                </div>
                              }
                            </div>
                            {this.state.item != null ? (
                              <ItemMintDescription item={this.state.item} />
                            ) : null}
                          </div>
                        </div>
                      </div>
                      {
                        this.state.item != null && this.state.item.history != null
                          ?
                        <div>
                        <div className="text-black dark:text-white mt-8 mb-4 font-semibold">
                          Price History
                        </div>
                        <div className="dark:bg-custom-black max-h-128 w-80 sm:w-112 p-2 mb-4 overflow-scroll">
                          {
                            this.state.item.history.map(historyItem => {
                              return (
                                <div className="flex flex-col mt-2 " key={historyItem.timestamp.toString() + "_" + historyItem.supplyDictatingPrice.toString()}>
                                  <div className="flex items-center">
                                    <img className="w-6 h-6 sm:w-8 sm:h-8" src={historyItem.userProfile} alt="Profile" />
                                    <div className="ml-4 text-black dark:text-white text-xs w-28 sm:w-28 sm:text-base font-normal dark:font-semibold"> {historyItem.displayedUserId} </div>
                                    <div> {
                                    historyItem.wasBurn ?
                                      <div className="ml-4 dark:text-red-600 text-xs sm:text-base w-28 sm:w-36 font-semibold ark:font-medium">
                                      sold an NFT for
                                      </div>
                                      :
                                      <div className="ml-4 dark:text-green-500 text-xs sm:text-base w-28 sm:w-36 font-semibold dark:font-medium">
                                      bought an NFT for
                                      </div>
                                    } </div>
                                    <div className="text-black dark:text-white text-xs sm:text-base font-semibold ml-4"> {historyItem.price + " ETH"} </div>
                                  </div>
                                  <div className="sm:ml-12 ml-10 dark:text-zinc-600 text-black dark:text-white text-xs font-normal ml-4"> {historyItem.timestamp.toString()} </div>
                                </div>
                              );
                            })
                          }
                        </div>
                        </div>
                          :
                        null
                      }
                      {
                        this.state.item.protocol === "liquid" || this.state.item.protocol === "liquidv2"
                          ?
                        <div className="hidden md:flex mt-4">
                          <BondingCurveAccordion address={this.props.account != null ? this.props.account.address : null} />
                        </div>
                          :
                        null
                      }
                    </div>
                    <div className="flex flex-col">
                    {
                      this.state.item != null
                        ?
                      (
                        <div>
                          <div className="lg:mt-0 mt-8">
                            <ItemMintDetails
                              setCrossmintUserId={this.setCrossmintUserId}
                              setTransactionStatus={this.setTransactionStatus}
                              authUUIDCrossmintClientMapping={this.state.authUUIDCrossmintClientMapping}
                              transactionStatus={this.state.transactionStatus}
                              item={this.state.item}
                              account={this.props.account}
                              protocol={this.state.protocol}
                              crossmintUserId={this.state.crossmintUserId}
                            />
                          </div>
                          {
                            this.state.item != null &&
                            this.state.item.authUUID in this.state.livestreamURLsByAuthUUID &&
                            this.state.shouldShowLiveStream &&
                            this.state.item.mediaType === 1
                              ?
                            (
                              <div className="w-96 h-96 flex flex-col items-center justify-center">
                                {this.state.isPlayingAudio ? (
                                  <FaPause
                                    onClick={this.onPlayAudio}
                                    className="playPauseButtonsBottom"
                                    height="2em"
                                  />
                                ) : (
                                  <FaPlay
                                    onClick={this.onPlayAudio}
                                    className="playPauseButtonsBottom"
                                    height="2em"
                                  />
                                )}
                                <img
                                  src={this.state.item.imagePinata}
                                  onClick={this.onPlayAudio}
                                  alt="PPV song"
                                />
                                {
                                  this.state.isActive &&
                                  this.state.stream != null 
                                    ?
                                  null
                                    :
                                  <PlatformMusicPlayer
                                    song={this.state.item}
                                    litDecrypt={this.litDecrypt}
                                    revokeAccess={this.revokeAccess}
                                    address={
                                      this.props.account != null ? this.props.account.address : null
                                    }
                                    onUserClickedConnectWallet={this.onUserClickedConnectWallet}
                                    updatePlayingStatus={this.updatePlayingStatus}
                                    backSong={() => {}}
                                    nextSong={() => {}}
                                  />
                                }
                              </div>
                            )
                              :
                            this.state.item != null &&
                            this.state.item.authUUID in this.state.livestreamURLsByAuthUUID &&
                            this.state.shouldShowLiveStream &&
                            this.state.item.mediaType === 0
                              ?
                            (
                              <div
                                onClick={async () => {
                                  if (!this.state.hasClicked) {
                                    await this.litDecrypt();
                                  }
                                }}
                              >
                                {
                                  this.state.item.protocol === "liquid" || this.state.item.protocol === "liquidv2"
                                    ?
                                  <video
                                    className="w-96 h-96 mt-8"
                                    src={this.state.item.animation_url}
                                    controls
                                    muted="muted"
                                  >
                                  </video>
                                    :
                                  <video
                                    className="w-96 h-96 mt-8"
                                    src={URL.createObjectURL(new Blob([this.state.itemFile]))}
                                    onEnded={async () => await this.revokeAccess()}
                                    poster={this.state.item != null && this.state.item.protocol === "the402" ? this.state.item.imagePinata : null}
                                    controls
                                    muted="muted"
                                  >
                                  </video>
                                }
                              </div>
                            )
                              :
                            this.state.item != null &&
                            this.state.item.authUUID in this.state.livestreamURLsByAuthUUID &&
                            this.state.shouldShowLiveStream &&
                            this.state.item.mediaType === 2
                              ?
                            (
                              <div className="w-96 h-96 flex flex-col items-center justify-center">
                                <img
                                  src={this.state.item.imagePinata}
                                  onClick={this.onPlayAudio}
                                  alt="PPV song"
                                />
                              </div>
                            )
                              :
                            null
                          }
                          </div>
                        ) : null}
                          <div className="w-96 sm:mr-16">
                            <ItemMintMonetizationDetails
                              account={this.props.account}
                              item={this.state.item}
                              protocol={this.state.protocol}
                              setTransactionStatus={this.setTransactionStatus}
                              transactionStatus={this.state.transactionStatus}
                            />
                          </div>
                          <div className="md:hidden flex">
                            <BondingCurveAccordion address={this.props.account != null ? this.props.account.address : null} />
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                    :
                  null
                }
              </div>
            </div>
          </div>
        </div>
        <TransactionStatus
          transactionStatus={this.state.transactionStatus}
          item={this.state.item}
        />
      </div>
    );
  }
}

export default ItemDedicatedPage;
